module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Zuad88/tc-custom/9781626813809.jpg?1705026229637",
      "alt": "This image is the cover for the book Murder of a Wife, The Michael Gray Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder of a Wife, The Michael Gray Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A San Francisco psychoanalyst turned amateur sleuth takes on the perplexing case of a pathological liar who thinks her husband wants to kill her.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Dr. Michael Gray is constantly getting drawn into the lives, and murders, of his troubled clientele. His keen eye for human behavior leads him to meet some of San Francisco’s most memorable denizens—and to forever be in mortal danger."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" After a shadowy figure attempts to bludgeon her in her bed, housewife Karen Champion believes her husband is out to get her. The problem is no one will believe anything Karen says."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" A known pathological liar, Karen can’t turn to the police—so she goes to the famous psychoanalyst Michael Gray for help. When she tells Gray what her husband is plotting, Gray is pulled deep into a world of quack doctors, a blackmailing private eye, and a killer who found that one vicious murder was only the beginning."), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("Praise for Henry Kuttner")]), _c('br'), _vm._v(" “A neglected master.” —Ray Bradbury"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Kuttner is magic.” —Joe R. Lansdale\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Henry Kuttner\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0